var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup4340 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4340",
    "data-name": "Group 4340",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.762,
    height: 13.21,
    viewBox: "0 0 15.762 13.21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-7",
    d: "M1,34.769H3.544V30H1Z",
    transform: "translate(-1 -23.323)",
    fill: "#047BC1",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-9",
    d: "M9,38.463c6.969,2.394,4.754,2.508,12.719-1.6-.705-.727-1.263-1.013-1.991-.8l-2.868.98",
    transform: "translate(-6.457 -27.415)",
    fill: "none",
    stroke: "#047BC1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-10",
    d: "M9,33h2.121a4.74,4.74,0,0,1,2.917,1.014c.885.008.954,0,2.121,0a.765.765,0,1,1,0,1.53H12.447",
    transform: "translate(-6.457 -25.369)",
    fill: "none",
    stroke: "#047BC1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Page-1",
    d: "M21.18,15.359s3.18-2.361,3.18-4.6-2.821-2.406-3.18-.172C20.821,8.358,18,8.53,18,10.936S21.18,15.359,21.18,15.359Z",
    transform: "translate(-12.595 -9)",
    fill: "#c8c8c8",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup4340);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group 4340.87e4896a601e0ef9226cd50b7967c9da.svg";